import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { PqrTimesActionsProps } from './props';
import { usePqrTimesListActions } from './hook';

export const PqrTimesListActions = ({ id }: PqrTimesActionsProps) => {
    const { handleEdit } = usePqrTimesListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
